(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("BuyACarCalculator", [], factory);
	else if(typeof exports === 'object')
		exports["BuyACarCalculator"] = factory();
	else
		root["BuyACarCalculator"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition